import { z } from 'zod';

/**
 * RatesDeskPayload — panel payload for the read-only "Rates Desk" dashboard
 * widget (issue: rates desk overview tile).
 *
 * This is a read-only report surface with minimal agent-driven filters:
 * - `as_of_date` lets the agent/template pin a specific business date
 *   (defaults to the live system business date when omitted).
 * - `book_id` is REQUIRED by the underlying GET /api/v1/portfolio/risk
 *   endpoint (see src/api/portfolioRisk.ts) — unlike /positions, bookId is
 *   not optional there. The widget surfaces a "select a book" placeholder
 *   (mirroring src/screens/reports/PortfolioRisk.tsx) until one is chosen,
 *   either via this payload field or interactively.
 */
export const RatesDeskPayloadSchema = z.object({
  as_of_date: z.string().optional(),
  book_id: z.string().optional(),
});

export type RatesDeskPayload = z.infer<typeof RatesDeskPayloadSchema>;
